const state = () => ({
  items: [],
  loading: false,
  error: null
})

const mutations = {
  setItems(state, items) {
    state.items = items || []
  },
  setLoading(state, value) {
    state.loading = !!value
  },
  setError(state, error) {
    state.error = error || null
  }
}

import { getApiUrl } from '@/config/api'

const actions = {
  async fetchItems({ state, commit }) {
    if (state.items.length) return
    commit('setLoading', true)
    commit('setError', null)
    try {
      const res = await fetch(getApiUrl('/api/items'))
      if (!res.ok) throw new Error(`HTTP ${res.status}`)
      const data = await res.json()
      commit('setItems', data.items || [])
    } catch (e) {
      console.error('Failed to load catalog items', e)
      commit('setError', e.message || 'Ошибка загрузки витрины')
    } finally {
      commit('setLoading', false)
    }
  }
}

const getters = {
  items: (state) => state.items,
  loading: (state) => state.loading,
  itemsByCategory: (state) => (category) =>
    category ? state.items.filter((i) => i.category === category) : state.items,
  sizeKeysUsed: (state) => {
    const set = new Set()
    state.items.forEach((i) => i.sizeKey && set.add(i.sizeKey))
    return Array.from(set)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

